module.exports = __webpack_public_path__ + "static/img/team.23ce024.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team.jpg
// module id = 9tXu
// module chunks = 1